var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fileTree"},[_c('FileTreeNode',{attrs:{"item":_vm.root},on:{"change":function($event){return _vm.$emit('change', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }